import { environment } from '@bvl-admin/environments/environment';

export class GeneralEndpoint {
  public static states = `${environment.LOAD_BALANCER}/system/parameterSystem/findByCodeMasterSystem/1`;
}
